export default {"src":"/_next/static/media/home.159a70d2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};